/* Anteprime audio dei Sample Pack, con forma d'onda.

   Un solo elemento <audio> per lettore: premendo un altro suono il primo si
   ferma da solo. A fine traccia parte la successiva. Nessun file audio viene
   scaricato finche' qualcuno non preme play.

   Forme d'onda:
   - se il prodotto ha il metacampo custom.waveform (JSON preparato con lo
     strumento a parte), le onde si disegnano subito, senza scaricare nulla;
   - se per una traccia manca, si calcola quando la traccia parte;
   - fino ad allora al posto dell'onda c'e' una linea sottile.
   Le chiavi del JSON sono il nome del file ridotto a lettere e cifre
   minuscole: "Bass 01 - Tension.mp3" e "Bass_01_-_Tension.mp3" danno
   entrambi "bass01tension", cosi' non importa come Shopify rinomina i file. */
(function () {
  /* Lo script puo' essere incluso due volte (demo in alto e anteprime in
     basso): gira una volta sola e serve tutti i lettori della pagina. */
  if (window.bnAnteprime) return;
  window.bnAnteprime = true;

  var ARANCIO = '#fc8503';
  var GRIGIO = 'rgba(255, 255, 255, 0.32)';
  var BARRA = 2, SPAZIO = 1;

  function tempo(s) {
    if (!isFinite(s) || s < 0) return '';
    s = Math.floor(s);
    return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
  }

  function chiave(url) {
    var n = String(url || '').split('?')[0].split('/').pop();
    try { n = decodeURIComponent(n); } catch (e) {}
    return n.replace(/\.[a-z0-9]{2,4}$/i, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  /* Lo stesso file servito dal dominio del negozio: evita i blocchi CORS
     quando si legge l'audio per calcolare l'onda. */
  function stessoDominio(url) {
    var m = String(url).match(/\/files\/([^\/?#]+)(\?[^#]*)?$/);
    return m ? location.origin + '/cdn/shop/files/' + m[1] + (m[2] || '') : null;
  }

  function calcolaPicchi(buffer, n) {
    var a = buffer.getChannelData(0);
    var b = buffer.numberOfChannels > 1 ? buffer.getChannelData(1) : null;
    var passo = Math.max(1, Math.floor(a.length / n));
    var salto = Math.max(1, Math.floor(passo / 400));
    var out = [], max = 0;
    for (var i = 0; i < n; i++) {
      var m = 0, fine = Math.min(a.length, (i + 1) * passo);
      for (var j = i * passo; j < fine; j += salto) {
        var v = Math.abs(a[j]);
        if (b) { var w = Math.abs(b[j]); if (w > v) v = w; }
        if (v > m) m = v;
      }
      out.push(m);
      if (m > max) max = m;
    }
    return out.map(function (v) { return max ? Math.round(v / max * 100) : 0; });
  }

  document.querySelectorAll('[data-bn-player]').forEach(function (lettore) {
    var audio = new Audio();
    audio.preload = 'none';
    var righe = Array.prototype.slice.call(lettore.querySelectorAll('[data-bn-traccia]'));
    var attiva = null;
    var contesto = null;

    /* Le forme d'onda si leggono da tutta la pagina: il JSON sta nel
       lettore in basso, ma serve anche alla demo in alto. */
    var onde = {};
    document.querySelectorAll('[data-bn-onde]').forEach(function (dati) {
      try {
        var o = JSON.parse(dati.textContent) || {};
        for (var k in o) onde[k] = o[k];
      } catch (e) {}
    });

    /* Ogni voce del JSON e' { d: durata in secondi, p: [picchi 0-100] };
       si accetta anche il solo elenco di picchi. */
    righe.forEach(function (riga) {
      var v = onde[chiave(riga.dataset.src)] || onde[chiave(riga.dataset.titolo)];
      var p = Array.isArray(v) ? v : (v && v.p);
      riga._picchi = Array.isArray(p) && p.length ? p : null;
      riga._durata = v && isFinite(v.d) ? v.d : null;
      riga._avanzamento = 0;
      riga.querySelector('.bn-player__tempo').textContent = riga._durata ? tempo(riga._durata) : '';
    });

    /* --- Disegno --- */

    function disegna(riga) {
      var tela = riga.querySelector('.bn-player__onda canvas');
      var dpr = window.devicePixelRatio || 1;
      var w = tela.clientWidth, h = tela.clientHeight;
      if (!w || !h) return;
      if (tela.width !== Math.round(w * dpr) || tela.height !== Math.round(h * dpr)) {
        tela.width = Math.round(w * dpr);
        tela.height = Math.round(h * dpr);
      }
      var c = tela.getContext('2d');
      c.setTransform(dpr, 0, 0, dpr, 0, 0);
      c.clearRect(0, 0, w, h);
      var fatto = riga._avanzamento * w;
      var picchi = riga._picchi;

      if (!picchi) {
        /* Nessuna onda ancora: una linea, che si riempie mentre suona. */
        var y = Math.round(h / 2) - 1;
        c.fillStyle = GRIGIO; c.fillRect(0, y, w, 2);
        c.fillStyle = ARANCIO; c.fillRect(0, y, fatto, 2);
        return;
      }

      var quante = Math.max(1, Math.floor((w + SPAZIO) / (BARRA + SPAZIO)));
      for (var i = 0; i < quante; i++) {
        var da = Math.floor(i * picchi.length / quante);
        var a = Math.max(da + 1, Math.floor((i + 1) * picchi.length / quante));
        var v = 0;
        for (var k = da; k < a && k < picchi.length; k++) if (picchi[k] > v) v = picchi[k];
        var alto = Math.max(2, v / 100 * h);
        var x = i * (BARRA + SPAZIO);
        c.fillStyle = x + BARRA / 2 <= fatto ? ARANCIO : GRIGIO;
        c.fillRect(x, (h - alto) / 2, BARRA, alto);
      }
    }

    function disegnaTutte() { righe.forEach(disegna); }

    /* --- Onda calcolata al volo, solo per le tracce senza JSON --- */

    function calcolaOnda(riga) {
      if (riga._picchi || riga._inCalcolo || !window.fetch) return;
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return;
      riga._inCalcolo = true;
      var src = riga.dataset.src;
      var vicino = stessoDominio(src);
      var scarica = vicino
        ? fetch(vicino).then(function (r) { if (!r.ok) throw 0; return r; }).catch(function () { return fetch(src); })
        : fetch(src);
      scarica
        .then(function (r) { if (!r.ok) throw 0; return r.arrayBuffer(); })
        .then(function (buf) {
          contesto = contesto || new AC();
          return new Promise(function (ok, ko) { contesto.decodeAudioData(buf, ok, ko); });
        })
        .then(function (buffer) { riga._picchi = calcolaPicchi(buffer, 160); disegna(riga); })
        .catch(function () { /* resta la linea: l'audio suona comunque */ });
    }

    /* --- Riproduzione --- */

    function stato(riga, suona) {
      var b = riga.querySelector('.bn-player__play');
      riga.classList.toggle('is-playing', suona);
      b.setAttribute('aria-pressed', suona ? 'true' : 'false');
      b.setAttribute('aria-label', (suona ? 'Pause ' : 'Play ') + riga.dataset.titolo);
    }

    function azzera(riga) {
      stato(riga, false);
      riga.classList.remove('is-active');
      riga._avanzamento = 0;
      riga.querySelector('.bn-player__tempo').textContent = riga._durata ? tempo(riga._durata) : '';
      var onda = riga.querySelector('.bn-player__onda');
      onda.setAttribute('tabindex', '-1');
      onda.setAttribute('aria-valuenow', '0');
      disegna(riga);
    }

    function suona(riga) {
      if (attiva && attiva !== riga) azzera(attiva);
      if (attiva !== riga) {
        attiva = riga;
        riga.classList.add('is-active');
        riga.querySelector('.bn-player__onda').setAttribute('tabindex', '0');
        audio.src = riga.dataset.src;
        calcolaOnda(riga);
      }
      var p = audio.play();
      if (p && p.catch) p.catch(function () {});
    }

    righe.forEach(function (riga) {
      riga.querySelector('.bn-player__play').addEventListener('click', function () {
        if (attiva === riga && !audio.paused) audio.pause();
        else suona(riga);
      });

      var onda = riga.querySelector('.bn-player__onda');
      onda.addEventListener('click', function (e) {
        var r = onda.getBoundingClientRect();
        var quota = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
        if (attiva !== riga) {
          /* Clic sull'onda di una traccia ferma: parte da quel punto. */
          suona(riga);
          audio.addEventListener('loadedmetadata', function una() {
            audio.removeEventListener('loadedmetadata', una);
            if (attiva === riga) audio.currentTime = quota * audio.duration;
          });
          return;
        }
        if (audio.duration) audio.currentTime = quota * audio.duration;
      });
      onda.addEventListener('keydown', function (e) {
        if (attiva !== riga || !audio.duration) return;
        if (e.key === 'ArrowRight') { audio.currentTime = Math.min(audio.duration, audio.currentTime + 5); e.preventDefault(); }
        if (e.key === 'ArrowLeft')  { audio.currentTime = Math.max(0, audio.currentTime - 5); e.preventDefault(); }
      });
    });

    audio.addEventListener('play',  function () {
      if (attiva) stato(attiva, true);
      document.dispatchEvent(new CustomEvent('bn:play', { detail: audio }));
    });
    /* Un solo suono alla volta in tutta la pagina: quando parte un altro
       lettore, questo si ferma. */
    document.addEventListener('bn:play', function (e) {
      if (e.detail !== audio && !audio.paused) audio.pause();
    });
    audio.addEventListener('pause', function () { if (attiva) stato(attiva, false); });

    audio.addEventListener('timeupdate', function () {
      if (!attiva || !audio.duration) return;
      attiva._avanzamento = audio.currentTime / audio.duration;
      attiva.querySelector('.bn-player__onda').setAttribute('aria-valuenow', Math.round(attiva._avanzamento * 100));
      attiva._durata = audio.duration;
      attiva.querySelector('.bn-player__tempo').textContent = tempo(audio.currentTime);
      disegna(attiva);
    });

    audio.addEventListener('ended', function () {
      var i = righe.indexOf(attiva);
      if (i > -1 && i < righe.length - 1) suona(righe[i + 1]);
      else if (attiva) { azzera(attiva); attiva = null; }
    });

    /* Ridisegna quando cambia la larghezza (rotazione del telefono,
       finestra ridimensionata) e quando i font hanno finito di caricare. */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { disegnaTutte(); });
      righe.forEach(function (r) { ro.observe(r.querySelector('.bn-player__onda')); });
    } else {
      window.addEventListener('resize', disegnaTutte);
    }
    disegnaTutte();
  });
})();
